<script setup>
import { PencilSquareIcon } from "@heroicons/vue/24/outline"

const props = defineProps({
  size: {
    required: true,
  },
  padding: {
    required: true,
  },
})
</script>

<template>
  <div class="flex">
    <div class="flex-shrink-0 group">
      <div class="relative w-full h-full" :class="`p-${padding === 0 ? size >= 20 ? '0' : padding/2  : padding/2}`">
        <PencilSquareIcon
          class="object-cover bg-gray-100"
          :class="`h-${size} w-${size} ${padding === 0  ? 'rounded-l-xl' : 'rounded-xl'}`"
        />
      </div>
    </div>
    <div>
      <div :class="`pl-${size >= 16 ? padding <= 2 ? '4' : '1' : '1'} p-${padding == 0 ? size >= 20 ? '2' : '0' : padding/2}`">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>
